import { apiRequest, applyQueryString } from '@/common/utils/request.common'
import { normalizeBaseHome } from '@/common/normalize'
import { API_BASE_URL, HTTP_METHOD_GET } from '@/common/utils/request.const'
import { HOME_API_ERROR_RESPONSE } from '@/common/resources/home-api-error-response'

/**
 * @typedef {object} RecommendHomeDetailParams
 * @property {string} seriesId
 * @property {string} contentId
 */

/**
 * @typedef {object} RecommendHomeLiveParams
 * @property {string} channelId
 * @property {string} seriesId
 * @property {string} genreCode
 */

/**
 * 콘텐츠 추천 홈 catalog api
 * @param homeCode DN1(vod) | DN2(movie) | DY1(live)
 * @param {(RecommendHomeDetailParams | RecommendHomeLiveParams | {})} params
 * @returns {Promise<undefined|*>}
 */
export const getRecommendHomeData = async ({ homeCode = '', params = {} }) => {
  try {
    const response = await apiRequest({
      url: applyQueryString(
        `${API_BASE_URL}/v1/home/detail/${homeCode}`,
        normalizeParams(params),
      ),
      method: HTTP_METHOD_GET,
    })

    response.data = normalizeBaseHome(response?.data?.data)

    return response
  } catch (e) {
    console.error(`Get Recommend Home Data Error Because :: ${e.message}`)

    return HOME_API_ERROR_RESPONSE
  }
}

/**
 * 콘텐츠 추천 홈 catalog api
 * @param {(RecommendHomeDetailParams | RecommendHomeLiveParams | {})} params
 * @return {Object.<string, string>}
 */
const normalizeParams = (params) => {
  if (params?.channelId) {
    return {
      channel_id: params.channelId,
      series_id: params?.seriesId ?? '',
      genre_code: params?.genreCode ?? '',
    }
  }
  return {
    series_id: params?.seriesId ?? '',
    content_id: params?.contentId ?? '',
  }
}
